/* @flow */

import { rem } from 'polished';

import {
  baseFontSize,
  captionFontSize,
  captionFontWeight,
  captionLineHeight,
} from '@braindate/ui/lib/token/typography';

export default {
  small: {
    fontSize: rem(captionFontSize, baseFontSize),
    fontWeight: captionFontWeight,
    lineHeight: captionLineHeight / captionFontSize,
  },
};
